<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar" />
      <section class="qi-content">
        <header>
          <h1>Auditoria</h1>
          <p style="font-size: 0.7em">
            * Clique no número do atendimento para visualizar e/ou atualizar a
            discussão do atendimento.
          </p>
        </header>

        <vs-row>
          <NewSale />
        </vs-row>

        <div style="margin-top: 10px">
          <vs-col vs-w="4" vs-sm="12">
            <b>Tipo</b>
            <fieldset
              style="
                display: flex;
                border-radius: 8.5px;
                padding: 8.5px;
                justify-content: space-around;
              "
            >
              <vs-radio v-model="type" vs-value="Matrícula">Matrícula</vs-radio>
              <vs-radio v-model="type" vs-value="Rematrícula"
                >Rematrícula</vs-radio
              >
            </fieldset>
          </vs-col>

          <vs-col vs-w="4" vs-sm="12">
            <b>Status</b>
            <fieldset
              style="
                display: flex;
                border-radius: 8.5px;
                padding: 8.5px;
                justify-content: space-around;
              "
            >
              <vs-radio v-model="typeStatus" vs-value="Reservada"
                >Reservada</vs-radio
              >
              <vs-radio v-model="typeStatus" vs-value="Confirmada"
                >Confirmada</vs-radio
              >
            </fieldset>
          </vs-col>
          <vs-col vs-w="4" vs-sm="12">
            <vs-button
              style="width: 100%; margin-top: 17.5px"
              icon="search"
              @click="findBy(type, typeStatus)"
            >
              Filtrar
            </vs-button>
          </vs-col>
        </div>

        <vs-divider />

        <div class="table-search-wrapper" v-if="audits && audits.length > 0">
          <div class="search-input-group">
            <vs-input
              type="text"
              v-model="searchTerm"
              placeholder="Pesquisar..."
              @keyup.enter="performSearch"
            />
            <vs-button
              icon="search"
              type="flat" 
              @click="performSearch"
            />
          </div>

          <vs-table
            class="pd-table"
            :max-items="pageSize"
            :data="audits"
            description
            :description-items="descriptionItems"
            description-title="Registros"
            description-connector="de"
            description-body="Mostrar"
          >
          <template slot="thead">
            <th style="width: 7.5%">Auditar</th>
            <th style="width: 7.5%" @click="sortData('CODATENDIMENTO')">
              Atendimento
            </th>
            <th style="width: 20.5%" @click="sortData('IDPREMATRICULA')">
              Pré-Matrícula
            </th>
            <th style="width: 18.5%" @click="sortData('RESPONSAVEL')">
              Responsável
            </th>
            <th style="width: 25%" @click="sortData('ALUNO')">Aluno/Curso</th>
            <th @click="sortData('CODSTATUS')">Status</th>
            <th style="width: 10%" @click="sortData('DESCRICAO_FORMAPGTO')">
              Parcelamento
            </th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr
              :data="tr"
              class="pointer"
              :key="indextr"
              v-for="(tr, indextr) in data"
            >
              <vs-td>
                <div class="b__important" style="text-align: center">
                  <vs-button
                    @click="showPopUp(data[indextr])"
                    color="primary"
                    type="filled"
                    icon="arrow_forward"
                  />
                </div>
              </vs-td>
              <vs-td>
                <div class="b__important" style="display: flex">
                  <div v-if="data[indextr].INCONSISTENCIA == '1'">
                    <vs-tooltip text="Divergência na Matrícula" position="top">
                      <span
                        style="font-size: 15px; margin-right: 5px"
                        class="material-icons"
                      >
                        info
                      </span>
                    </vs-tooltip>
                  </div>
                  <a href="#" @click="showDiscussionScreen(data[indextr])">
                    {{ data[indextr].CODATENDIMENTO }}
                  </a>
                </div>
              </vs-td>
              <vs-td>
                <div class="b__important" style="margin-bottom: 3.5px">
                  {{ data[indextr].IDPREMATRICULA }}
                </div>
                <div class="b__small" style="margin-bottom: 1.5px">
                  <div style="display: flex">
                    <span
                      style="font-size: 12.5px; margin-right: 3.5px"
                      class="material-icons"
                    >
                      monetization_on
                    </span>
                    <span>
                      {{ data[indextr].VENDEDORNOME.toUpperCase() }}
                    </span>
                  </div>
                </div>
                <div class="b__small" style="margin-bottom: 1.5px">
                  <div style="display: flex">
                    <span
                      style="font-size: 12.5px; margin-right: 3.5px"
                      class="material-icons"
                    >
                      place
                    </span>
                    <span>
                      {{ data[indextr].FILIAL_MATRICULOU_NOME.toUpperCase() }}
                    </span>
                  </div>
                </div>
                <div class="b__small">
                  <div style="display: flex">
                    <span
                      style="font-size: 12.5px; margin-right: 3.5px"
                      class="material-icons"
                    >
                      event
                    </span>
                    <span>
                      {{ data[indextr].DATACRIACAOPRE }}
                    </span>
                  </div>
                </div>
              </vs-td>
              <vs-td>
                <div class="b__important" style="margin-bottom: 2.85px">
                  {{
                    data[indextr].RESPONSAVELSOCIAL != "-"
                      ? data[indextr].RESPONSAVELSOCIAL
                      : data[indextr].RESPONSAVEL
                  }}
                </div>
                <div class="b__small">
                  <div style="display: flex">
                    <span
                      style="font-size: 12.5px; margin-right: 3.5px"
                      class="material-icons"
                    >
                      account_circle
                    </span>
                    <span>
                      {{ data[indextr].CODRESPONSAVEL }}
                    </span>
                  </div>
                </div>
              </vs-td>
              <vs-td>
                <div
                  v-if="data[indextr].EMANCIPADO == 'S'"
                  class="b__small"
                  style="margin-bottom: 6.5px"
                >
                  <div style="display: flex">
                    <span
                      style="font-size: 12.5px; margin-right: 3.5px"
                      class="material-icons"
                    >
                      assignment_ind
                    </span>
                    <b> EMANCIPADO </b>
                  </div>
                </div>
                <div class="b__important" style="margin-bottom: 1.5px">
                  {{
                    data[indextr].ALUNOSOCIAL != "-"
                      ? data[indextr].ALUNOSOCIAL
                      : data[indextr].ALUNO
                  }}
                </div>
                <div class="b__small" style="margin-bottom: 5px">
                  {{ data[indextr].NOMECOMERCIAL }}
                </div>
                <div v-if="data[indextr].DESCRICAO_INGRESSO" class="b__small">
                  <div style="display: flex">
                    <span
                      style="font-size: 12.5px; margin-right: 3.5px"
                      class="material-icons"
                    >
                      play_arrow
                    </span>
                    <span>
                      {{ data[indextr].DESCRICAO_INGRESSO }}
                    </span>
                  </div>
                </div>
              </vs-td>
              <vs-td>
                <div :class="formatStatus(data[indextr].CODSTATUS)">
                  {{ data[indextr].CODSTATUS.toUpperCase() }}
                </div>
                <div class="b__small" style="margin-bottom: 5px">
                  {{ data[indextr].DESCRICAO }}
                </div>
                <div
                  class="b__small"
                  v-if="data[indextr].USUCONFIRMACAO == 'dani.qi'"
                >
                  <div style="display: flex">
                    <span
                      style="font-size: 13.5px; margin-right: 3.5px"
                      class="material-icons"
                    >
                      account_circle
                    </span>
                    <span>
                      {{ data[indextr].USUCONFIRMACAO }}
                    </span>
                  </div>
                </div>
              </vs-td>
              <vs-td>
                <div
                  class="b__important"
                  style="text-align: center; margin-bottom: 2.85px"
                >
                  {{ data[indextr].DESCRICAO_FORMAPGTO }}
                </div>
                <div
                  class="b__small"
                  v-if="data[indextr].DESCRICAO_FORMAPGTO == 'RECORRENTE'"
                >
                  <div
                    v-if="data[indextr].CARTAOCADASTRADO == 'N'"
                    style="display: flex; justify-content: center; color: red"
                  >
                    <span
                      style="font-size: 12.5px; margin-right: 3.5px"
                      class="material-icons"
                    >
                      remove_circle
                    </span>
                    <span> Não Cadastrado </span>
                  </div>
                  <div
                    v-if="data[indextr].CARTAOCADASTRADO == 'S'"
                    style="display: flex; justify-content: center; color: green"
                  >
                    <span
                      style="font-size: 12.5px; margin-right: 3.5px"
                      class="material-icons"
                    >
                      check_circle
                    </span>
                    <span> Cadastrado </span>
                  </div>
                </div>
              </vs-td>
            </vs-tr>
          </template>
          </vs-table>

          <div style="display: flex; justify-content: center; align-items: center; margin-top: 1.5rem;">
            <vs-button @click="previousPage" :disabled="page <= 1" icon="arrow_back">
              <p class="pagButton">Anterior</p>
            </vs-button>
            <span style="margin-left: 25px; margin-right: 25px; font-size: 1.1em;">
              Página {{ page }}
            </span>
            <vs-button @click="nextPage" :disabled="!hasMorePages" icon-after icon="arrow_forward">
              <p class="pagButton">Próxima</p>
            </vs-button>
          </div>
        </div>

        <vs-alert color="danger" icon="new_releases" v-else>
          <b>Sem resultados para serem mostrados</b>
        </vs-alert>
        <vs-popup
          :title="
            this.selectedMailing != null
              ? 'Atendimento - ' + this.selectedMailing.CODATENDIMENTO
              : 'Atendimento'
          "
          :active.sync="discussionScreen"
        >
          <vs-card>
            <vs-tabs alignment="center">
              <vs-tab icon="edit" label="Atualizar Discussão">
                <vs-row>
                  <vs-col>
                    <vs-textarea
                      v-model="discussionText"
                      height="10rem"
                      label="Informe o texto para atualizar a discussão do atendimento"
                    />
                  </vs-col>
                </vs-row>
                <vs-row>
                  <vs-button
                    icon="check_circle"
                    color="#139B0E"
                    style="width: 100%"
                    :disabled="!discussionText"
                    @click="updateDiscussion()"
                  >
                    Atualizar
                  </vs-button>
                </vs-row>
              </vs-tab>
              <vs-tab icon="group" label="Histórico">
                <p v-html="history"></p>
              </vs-tab>
            </vs-tabs>
          </vs-card>
        </vs-popup>
        <vs-popup
          title="Contate o Cliente"
          :active.sync="activePopup"
          v-if="selectedPre"
        >
          <vs-row>
            <vs-col>
              <div style="display: flex">
                <span
                  style="
                    margin-top: 7.15px;
                    color: #9b0e1c;
                    margin-right: -2.5px;
                    font-size: 20px;
                  "
                  class="material-icons"
                >
                  headset_mic
                </span>
                <p>
                  Telefone(s):
                  <strong>{{ selectedPre.TELEFONE1RESPONSAVEL }}</strong>
                  <strong v-if="selectedPre.TELEFONE2RESPONSAVEL">
                    - {{ selectedPre.TELEFONE2RESPONSAVEL }}</strong
                  >
                  <strong v-if="selectedPre.TELEFONE3RESPONSAVEL">
                    - {{ selectedPre.TELEFONE3RESPONSAVEL }}</strong
                  >
                </p>
              </div>
              <div style="display: flex">
                <span
                  style="
                    margin-top: 7.15px;
                    color: #9b0e1c;
                    margin-right: -2.5px;
                    font-size: 20px;
                  "
                  class="material-icons"
                >
                  email
                </span>
                <p>
                  E-mail:
                  <strong>{{ selectedPre.EMAILRESPONSAVEL }}</strong>
                </p>
              </div>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col
              v-if="
                selectedPre.CODSTATUS == 'Reservada' ||
                selectedPre.USUCONFIRMACAO == 'dani.qi'
              "
              vs-lg="6"
              vs-xs="12"
            >
              <vs-button
                icon="monetization_on"
                style="width: 100%"
                @click="startSimulation(selectedPre, '/audits/3')"
                type="filled"
                color="danger"
              >
                Conferir Valores
              </vs-button>
            </vs-col>
            <vs-col
              v-if="
                selectedPre.CODSTATUS == 'Reservada' ||
                selectedPre.USUCONFIRMACAO == 'dani.qi'
              "
              vs-lg="6"
              vs-xs="12"
            >
              <vs-button
                icon="book"
                style="width: 100%"
                @click="startSimulation(selectedPre, '/audits/2')"
                type="filled"
                color="#3750db"
              >
                Conferir Acadêmico
              </vs-button>
            </vs-col>
            <vs-col
              v-if="
                selectedPre.CODSTATUS == 'Reservada' ||
                selectedPre.USUCONFIRMACAO == 'dani.qi'
              "
              vs-w="12"
            >
              <vs-button
                icon="send"
                style="width: 100%"
                @click="startSimulation(selectedPre, '/audits/1a')"
                type="filled"
                color="#139B0E"
              >
                Encaminhar para Auditoria
              </vs-button>
            </vs-col>
            <vs-col v-if="selectedPre.CODSTATUS == 'Confirmada'" vs-w="12">
              <vs-button
                icon="description"
                style="width: 100%"
                @click="resendContract()"
                type="filled"
                color="danger"
              >
                Reenviar Contrato para Assinatura
              </vs-button>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-card>
              <div>
                <vs-alert title="Erro no processo" color="danger" v-if="error">
                  {{ error }}
                </vs-alert>
              </div>
              <div>
                <p>
                  <vs-select
                    name="motivocancelamento"
                    width="100%"
                    v-model="motivoSelecionado"
                    placeholder="Selecione um Motivo de Cancelamento"
                  >
                    <vs-select-item
                      :key="index"
                      :value="option.value"
                      :text="option.text"
                      v-for="(option, index) in dadosCancel.reasonCancel"
                    />
                  </vs-select>
                </p>
              </div>
              <div>
                <vs-button
                  icon="highlight_off"
                  :disabled="!this.motivoSelecionado"
                  style="width: 100%; margin-top: 10px"
                  @click="openAlert(selectedPre)"
                >
                  Cancelar Pré-Matrícula
                </vs-button>
              </div>
            </vs-card>
          </vs-row>

          <vs-row v-if="errorCancel">
            <vs-alert
              color="danger"
              icon="new_releases"
              title="Erro ao Cancelar"
            >
              <p>{{ errorCancel }}</p>
            </vs-alert>
          </vs-row>
          <vs-row v-if="errorSendContract">
            <vs-alert
              color="danger"
              icon="new_releases"
              title="Erro ao tentar reenviar contrato"
            >
              <p>{{ errorSendContract }}</p>
            </vs-alert>
          </vs-row>
          <vs-row v-if="success">
            <vs-alert color="success" icon="new_releases" title="Sucesso">
              <p>{{ success }}</p>
            </vs-alert>
          </vs-row>
        </vs-popup>
      </section>
    </div>
  </div>
</template>

<script>
import sortBy from "sort-by";
import Mailing from "../services/mailing";
import Audits from "../services/audits";
import preRegistration from "../services/preRegistration";
import moment from "moment";
import {
  updateStepsInformation,
  getStepsInformation,
} from "../helpers/storage";
import { notifySuccess, onlyUpdateDiscussion } from "../helpers";

export default {
  name: "Audits",
  data: () => ({
    dadosCancel: {
      reasonCancel: [
        { text: "SE - Divergência Financeira", value: "09" },
        { text: "SE - Divergência Acadêmica", value: "10" },
        { text: "SE - Sem Contato", value: "11" },
        { text: "SE - Desistência Perda de Interesse", value: "12" },
        { text: "SE - Divergência no Processo", value: "13" },
        { text: "SE - Email Não Pertence ao Responsável", value: "20" },
      ],
    },
    pre: null,
    motivoSelecionado: null,
    descriptionItems: [10, 50, 100],
    audits: [],
    error: null,
    type: "Matrícula",
    typeStatus: "Reservada",
    typePayment: null,
    activePopup: false,
    phone1: null,
    phone2: null,
    selectedPre: null,
    errorCancel: null,
    errorSendContract: null,
    card: null,
    preRegistrationId: null,
    success: null,
    selectedMailing: null,
    discussionScreen: false,
    discussionText: null,
    history: null,
    sortProperty: "CODATENDIMENTO", // Propriedade inicial para ordenação
    sortOrder: "asc", // Ordem inicial da ordenação
    page: 1, // Página inicial
    pageSize: 10, // Quantidade de itens por página
    hasMorePages: true,
    searchTerm: "",
  }),
  created() {
    const stepsData = getStepsInformation();
    this.preRegistrationId = stepsData.preRegistrationId;
    this.findBy(this.type, this.typeStatus);
  },

  methods: {
    sortData(property) {
      if (this.sortProperty === property) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortProperty = property;
        this.sortOrder = "asc";
      }

      this.audits.sort(
        sortBy(this.sortOrder === "asc" ? property : `-${property}`)
      );
    },

    async getDiscussion(CODCOLIGADA, CODLOCAL, CODATENDIMENTO) {
      await new Mailing()
        .getDiscussion(CODCOLIGADA, CODLOCAL, CODATENDIMENTO)
        .then(({ data }) => {
          this.history = data.TEXTODISCUSSAO.replaceAll("\n", "<br />");
          this.$vs.loading.close();
        });
    },

    async showDiscussionScreen(data) {
      this.selectedMailing = data;
      this.$vs.loading();
      await this.getDiscussion(
        (data.CODCOLIGADA = 1),
        data.CODLOCAL,
        data.CODATENDIMENTO
      );
      this.discussionScreen = true;
      this.discussionText = null;
    },

    formatStatus(status) {
      switch (status) {
        case "Reservada":
          return "reserved";
        case "Confirmada":
          return "confirmed";
        default:
          return "normalStatus";
      }
    },

    async updateDiscussion() {
      this.$vs.loading();
      await onlyUpdateDiscussion(
        this.discussionText,
        this.selectedMailing.CODCOLIGADA,
        this.selectedMailing.CODLOCAL,
        this.selectedMailing.CODATENDIMENTO
      ).finally(() => {
        this.discussionScreen = false;
        this.$vs.loading.close();
      });
    },

    showPopUp(pre) {
      this.selectedPre = pre;
      this.activePopup = true;
      this.motivoSelecionado = null;
    },

    openAlert() {
      this.$vs.dialog({
        color: "danger",
        title: "Confirmação",
        text: "Confirma o cancelamento da pré-matrícula?",
        type: "confirm",
        accept: this.acceptAlert,
      });
    },

    acceptAlert() {
      this.activePopup = false;
      this.cancel(this.selectedPre, this.motivoSelecionado);
    },

    startSimulation(pre, route) {
      updateStepsInformation({
        codColigada: pre.CODCOLIGADA,
        preRegistrationId: pre.IDPREMATRICULA,
      });
      this.$router.push(route);
    },

    performSearch() {
      this.page = 1;
      if (this.searchTerm) {
        this.findAttendance();
      } else {
        this.findBy(this.type, this.typeStatus);
      }
    },

    async findAttendance() {
      this.$vs.loading();

      const payload = {
        filter: this.searchTerm
      };

      await new Audits()
        .getAudit(payload)
        .then((response) => {
          if (response && response.data) {
            let audits = Array.isArray(response.data) ? response.data : [response.data];
            
            let auditsMap = audits.map((a) => {
              a.TIPO = a.TIPOMAT == "MA" ? "Matrícula" : "Rematrícula";
              a.CODSTATUS = a.CODSTATUS == "RE" ? "Reservada" : "Confirmada";
              a.FILIAL_MATRICULOU_NOME =
                a.FILIAL_MATRICULOU_NOME == "FL07 - ADMINISTRAÇÃO"
                  ? "FL07 - MANTENEDORA"
                  : a.FILIAL_MATRICULOU_NOME ==
                    "FL15 - QI MARECHAL FLORIANO - CAXIAS DO SUL"
                  ? "FL15 - QI CAXIAS DO SUL"
                  : a.FILIAL_MATRICULOU_NOME;
              a.DESCRICAO_FORMAPGTO =
                a.DESCRICAO_FORMAPGTO.toUpperCase() === "CRÉDITO RECORRENTE" ||
                a.DESCRICAO_FORMAPGTO.toUpperCase() === "CREDITO RECORRENTE"
                  ? "RECORRENTE"
                  : a.DESCRICAO_FORMAPGTO.toUpperCase();

              return a;
            });

            this.audits = auditsMap;
            this.hasMorePages = false;
          } else {
            this.audits = [];
          }
        })
        .catch(({ response }) => {
          if (response && response.data) {
            this.error = response.data.error;
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    nextPage() {
      if (this.hasMorePages) {
        this.page++;
        this.findBy(this.type, this.typeStatus);
      }
    },

    previousPage() {
      if (this.page > 1) {
        this.page--;
        this.findBy(this.type, this.typeStatus);
      }
    },

    async findBy(type, status) {
      this.$vs.loading();

      const payload = {
        valorIni_n: (this.page - 1) * this.pageSize,
        valorPagina_n: this.pageSize,
      };

      await new Audits()
        .getAudits(payload)
        .then((response) => {
          let audits = Array.isArray(response.data)
            ? response.data
            : [response.data];
            
          let auditsMap = audits.map((a) => {
            a.TIPO = a.TIPOMAT == "MA" ? "Matrícula" : "Rematrícula";
            a.CODSTATUS = a.CODSTATUS == "RE" ? "Reservada" : "Confirmada";
            a.FILIAL_MATRICULOU_NOME =
              a.FILIAL_MATRICULOU_NOME == "FL07 - ADMINISTRAÇÃO"
                ? "FL07 - MANTENEDORA"
                : a.FILIAL_MATRICULOU_NOME ==
                  "FL15 - QI MARECHAL FLORIANO - CAXIAS DO SUL"
                ? "FL15 - QI CAXIAS DO SUL"
                : a.FILIAL_MATRICULOU_NOME;
            a.DESCRICAO_FORMAPGTO =
              a.DESCRICAO_FORMAPGTO.toUpperCase() === "CRÉDITO RECORRENTE" ||
              a.DESCRICAO_FORMAPGTO.toUpperCase() === "CREDITO RECORRENTE"
                ? "RECORRENTE"
                : a.DESCRICAO_FORMAPGTO.toUpperCase();

            return a;
          });
          
          this.audits = auditsMap.filter(
            (a) => a.TIPO == type && a.CODSTATUS == status
          );

          this.hasMorePages = audits.length === this.pageSize;
        })
        .catch(({ response }) => {
          if (response && response.data) {
            this.error = response.data.error;
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    resendContract() {
      this.errorSendContract = null;
      this.success = null;
      this.$vs.loading();
      const payload = {
        colligateId: "1",
        RA: this.selectedPre.RA,
        idPerLet: this.selectedPre.IDPERLET,
        contractId: this.selectedPre.CODCONTRATO,
        qualificationId: this.selectedPre.IDHABILITACAOFILIAL,
      };
      new Audits()
        .requestSignature(payload)
        .then(() => {
          this.$vs.loading.close();
          this.success = "Contrato enviado com sucesso!";
          //notifySuccess(this, "Contrato enviado com sucesso!");
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.errorSendContract =
            "Erro na tentativa de reenviar o contrato: " +
            error.response.data.error;
        });
    },

    cancel(data, reasonId) {
      this.$vs.loading();
      const payload = {
        reasonId: reasonId,
        coligateId: 1,
        localId: data.CODLOCAL,
        attendanceId: data.CODATENDIMENTO,
        bankData: "",
      };
      this.error = null;
      new preRegistration()
        .cancel(payload, data.IDPREMATRICULA)
        .then(() => {
          notifySuccess(this, "Pré cancelada com sucesso!");
          this.findByMatriculation();
        })
        .catch((error) => {
          this.errorCancel =
            "Erro ao tentar cancelar a pré: " + error.response.data.error;
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
  },

  filters: {
    moment: function (date) {
      moment.locale("pt-br");
      return moment(date).format("DD/MM/YYYY");
    },
  },
};
</script>
<style>
.reserved,
.confirmed,
.normalStatus {
  font-weight: bold;
}

.table-search-wrapper {
  position: relative;
  padding-top: 45px; 
}

.search-input-group {
  position: absolute;
  top: 0; 
  right: 15px;
  z-index: 10;
  width: 220px; 
  display: flex;
  align-items: center;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  overflow: hidden;
  background-color: white;
}

.reserved {
  color: #ffa500;
}

.confirmed {
  color: #00aa00;
}

.normalStatus {
  color: #000000;
}

th:nth-child(n) {
  padding: 0.5rem 0.5rem 0.5rem 0.7rem;
}

th:hover {
  opacity: 0.8;
}
</style>
